The event signaling that a candidate has applied for a `PositionOpening`.

A candidate may apply for the same position opening more than once.
Each application will trigger a new event with a distinct `id`.
